'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Milestone(title, text) {
  this.hE = null;
  this.hD = null;
  this.hE = title;
  this.hD = text;
}
export { $c_Lio_intela_sites_intelacloud_content_Milestone as $c_Lio_intela_sites_intelacloud_content_Milestone };
$p = $c_Lio_intela_sites_intelacloud_content_Milestone.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Milestone;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Milestone() {
}
export { $h_Lio_intela_sites_intelacloud_content_Milestone as $h_Lio_intela_sites_intelacloud_content_Milestone };
$h_Lio_intela_sites_intelacloud_content_Milestone.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-413760778), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Milestone) && ((this.hE === x$0.hE) && (this.hD === x$0.hD))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Milestone";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.hE;
  }
  if ((n === 1)) {
    return this.hD;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Milestone(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bB)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Milestone as $isArrayOf_Lio_intela_sites_intelacloud_content_Milestone };
var $d_Lio_intela_sites_intelacloud_content_Milestone = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Milestone, "io.intela.sites.intelacloud.content.Milestone", ({
  bB: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Milestone as $d_Lio_intela_sites_intelacloud_content_Milestone };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Milestone.js.map
